import { Injectable, EventEmitter } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { IGrid } from 'src/app/shared/models';

let users: IUser[] = [];
@Injectable({
  providedIn: 'root'
})
export class UsersService extends BaseService {
  private selectedFolder = new Subject<any>();
  private selectedReport = new Subject<any>();
  selectedUserId: string;

  constructor(protected http: HttpClient) {
    super(http);
  }

  saveUsers = new EventEmitter<any>();

  regions: IRegion2[] = [];

  getUsers(): Observable<IUser[]> {
    const url = 'Admin/GetUsers';
    return this.get(url, {}).pipe(map(res => {
      users = res;
      return users;
    }));
  }

  getSavedUsers(id: string) {
    const $user = users.find(f => f.id === id);
    const user = new Observable(obs => {
      obs.next($user);
    });
    return user;
  }

  createUser(obj: IUser) {
    const objEx = this.prepareObjUser(obj);
    const url = 'api/Account/Register';
    return this.post(url, objEx);
  }

  editUser(obj: IUser) {
    const objEx = this.prepareObjUser(obj);
    const url = 'api/Account/Edit';
    return this.post(url, objEx);
  }

  getUserRegions(userId: string): Observable<IRegion2[]> {
    const url = 'Admin/GetUserRegions';
    return this.get(url, { userId });
  }

  getRegionList(): Observable<IRegion2[]> {
    return this.get('Admin/GetRegionList', {}).pipe(map(res => {
      this.regions = res;
      return this.regions;
    }));
  }

  getRegions() {
    return this.regions;
  }

  setUserRegions(regionIds: string, userId: string) {
    return this.post(`Admin/SetUserRegions?regionIds=${regionIds}&userId=${userId}`, {});
  }

  prepareObjUser(obj: IUser) {
    let phoneNumber = obj.phoneNumber;
    if (phoneNumber && phoneNumber.length === 10) {
      phoneNumber = '+7' + phoneNumber;
    }
    const objEx = {
      id: obj.id,
      email: obj.email,
      lastName: obj.lastName,
      firstName: obj.firstName,
      middleName: obj.middleName,
      mioID: obj.mioID,
      Password: obj.Password,
      ConfirmPassword: obj.ConfirmPassword,
      roles: obj.roles,
      phoneNumber: phoneNumber,
      companyID: obj.companyID,
      departmentID: obj.departmentID,
      lockoutEnabled: obj.lockoutEnabled
    };
    return objEx;
  }

  getUserFolders(userGuid: string): Observable<IFolder[]> {
    return this.get('Folders/GetAll', { userGuid }).pipe(map(res => {
      return res;
    }));
  }

  setFolder(name: string, userGuid: string, id?: number) {
    return this.get('Folders/Set', { name, id, userGuid });
  }

  deleteFolders(ids: number[]) {
    const url = 'Folders/Delete';
    return this.post(url, ids);
  }

  getUserReports(folderId: number, userGuid: string): Observable<IDashboard[]> {
    return this.get('Dashboards/GetByFolderId', { folderId, userGuid }).pipe(map(res => {
      return res;
    }));
  }

  createReport(folderId: number, title: string, userGuid: string) {
    return this.get('Dashboards/CreateByFolder', { folderId, title, userGuid }).pipe(map(res => {
      return res;
    }));

  }

  renameReport(dashboardId: number, name: string) {
    return this.post(`Dashboards/RenameDashboard?dashboardId=${dashboardId}&name=${name}`, {});
  }

  deleteReports(ids: number[]) {
    const url = 'Dashboards/Delete';
    return this.post(url, ids);
  }
  setSelectedUserId(id: string) {
    this.selectedUserId = id;
  }

  setSelectedFolderId(id: number) {
    this.selectedFolder.next(id);
  }

  getSelectedFolder(): Observable<any> {
    return this.selectedFolder.asObservable();
  }

  getSelectedReport(): Observable<any> {
    return this.selectedReport.asObservable();
  }

  setSelectedReportId(id: number) {
    this.selectedReport.next(id);
  }

  // getFolderById(id: number) {
  //   return this.get('Folders/GetById', { id }).pipe(map(res => {
  //     return res;
  //   }));
  // }

  getWidgetsByDashboardId(dashboardId: number, userGuid: string): Observable<IGrid[]> {
    const url = 'Grids/GetByDashboardId';
    return this.get(url, { dashboardId, userGuid });

  }

  deleteWidget(id: number) {
    const url = 'Grids/Delete';
    return this.get(url, { id });
  }



  deleteMultipleWidgets(model: IMultipleDeleteWidgets): Observable<IMultipleDeleteWidgets> {
    return this.http.post<IMultipleDeleteWidgets>(this.apiUrl + 'Grids/MultipleDelete', model);
  }


  shareDashboards(receiverId: string[], dashboardIds: number[]) {
    return this.post('Dashboards/Share', {
      receiverIds: receiverId,
      dashboardIds: dashboardIds
    });
  }

  getFoldersByRedFolder(): Observable<IFolder[]> {
    return this.get('Folders/GetFoldersByRedFolder', {});
  }

  getFolders(): Observable<IFolder[]> {
    return this.get('Folders/GetAll', {});
  }

  getRedFolder(): Observable<IFolder> {
    return this.get('Folders/GetStaticRed', {});
  }

  getDashboardUsers() {
    return this.get('Users/GetDashboardUsers', {});
  }

}


export interface IUser {
  id?: string;
  email: string;
  lastName: string;
  firstName: string;
  middleName: string;
  mioID: number;
  phoneNumber: string;
  Password?: string;
  ConfirmPassword?: string;
  roles: string[];
  companyID: number;
  departmentID: number;
  lockoutEnabled?: boolean;
}


export interface IRegion2 {
  id: number;
  title: string;
}

export interface IFolder {
  id: number;
  name: string;
}

export interface IMultipleDeleteWidgets {
  ids: number[];
  dashboardId: number;
}

export interface IFolder {
  id: number;
  name: string;
  isSharedFolder: boolean;
  isRedFolder: boolean;
  ownerUserId: number;
  screensCount: number;
  selected?: boolean;
  rename?: boolean;
  isChecked: boolean;
  hovered: boolean;
  visibleMenu: boolean;
  totalUsers: number;
  users: IUser[];

  // все разрешения
  viewGrant?: boolean;
  shareGrant?: boolean;
  deleteGrant?: boolean;
  renameGrant?: boolean;
  createReportGrant?: boolean;
  deleteReportGrant?: boolean;
  permissions?: Array<'View' | 'Share' | 'Delete' | 'Rename' | 'CreateReport' | 'DeleteReport'>;
}

export interface IDashboard {
  id: number;
  folderId: number;
  numberPath: string;
  number: number;
  title: string;
  screensCount: number;
  isChecked?: boolean;
  selected?: boolean;
  rename?: boolean;
  hovered: boolean;
  visibleMenu: boolean;
  receiverUsers?: string[];
  senderUsers?: string[];
  isAdminDashboard?: boolean;


  // все разрешения
  viewGrant?: boolean;
  shareGrant?: boolean;
  deleteGrant?: boolean;
  renameGrant?: boolean;
  createWidgetGrant?: boolean;
  deleteWidgetGrant?: boolean;

  permissions?: Array<'View' | 'Share' | 'Delete' | 'Rename' | 'CreateWidget' | 'DeleteWidget'>;
  map?: any;
}

